import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useSEO } from "../lib/useSEO";
import { Container, SectionHeading, CTAButton, Reveal } from "../components/site/ui";

const IMAGES = [
  "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "https://images.unsplash.com/photo-1701313056413-0915e1adf204?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "https://images.unsplash.com/photo-1772541225216-bd4418ed0397?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
];

export default function Industries() {
  const { t, lang } = useLang();
  const ind = t.industries;
  useSEO({ title: ind.metaTitle, description: ind.metaDesc, path: "/industries", lang });

  return (
    <div>
      <section className="pt-28 pb-16 border-b border-cool-dark" data-testid="industries-hero">
        <Container><SectionHeading eyebrow={ind.eyebrow} title={ind.title} intro={ind.intro} /></Container>
      </section>

      <section className="py-16" data-testid="industries-grid">
        <Container>
          <div className="grid gap-px bg-cool-dark border border-cool-dark sm:grid-cols-2 lg:grid-cols-3">
            {ind.items.map((item, i) => (
              <Reveal key={i} delay={(i % 3) * 0.06} className="bg-nb-base">
                <div className="relative h-40 overflow-hidden border-b border-cool-dark">
                  <img src={IMAGES[i % IMAGES.length]} alt={item.t} loading="lazy"
                       className="w-full h-full object-cover opacity-40" />
                  <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(11,17,32,0.2), rgba(11,17,32,0.9))" }} />
                  <span className="absolute bottom-3 left-4 font-mono text-xs text-cyan">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg text-white">{item.t}</h3>
                  <p className="mt-2 text-sm text-cool-light leading-relaxed">{item.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14"><CTAButton to="/pilot-program" variant="primary" testId="industries-cta">{t.common.applyPilot}</CTAButton></Reveal>
        </Container>
      </section>
    </div>
  );
}
